import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';
import { SeachQuery } from '../../shared/models';


@Injectable({
    providedIn: 'root'
})
export class RiderService {
    constructor(
        private http_client: ApiService
    ) { }

    async getRidersByBond(bondNo: any) {
        debugger
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Riders/bond/${bondNo}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getAllRiders(searchQuery: SeachQuery) {
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Riders?pageNo=${searchQuery.pageNo}&pageSize=${searchQuery.pageSize}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async deleteRider(rider_id: number) {
        debugger
        try {
            const response = await this.http_client.deleteData(Constant.new_base_url
                + `api/Riders/${rider_id}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async addNewRider(rider_data: any) {
        debugger
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/Riders`, rider_data);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async getRiderById(rider_id: any) {
        debugger
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Riders/${rider_id}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async editRiderDetails(rider_data: any) {
        debugger
        try {
            const response = await this.http_client.putData(Constant.new_base_url
                + `api/Riders`, rider_data);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
}